var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartoComponentsLogoWatermark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20.9%",
    y: "-16.7%",
    width: "141.8%",
    height: "141.7%",
    filterUnits: "objectBoundingBox",
    id: "carto-components-logo-watermark_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    "in": "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter3",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-9.4%",
    y: "-50%",
    width: "118.9%",
    height: "225%",
    filterUnits: "objectBoundingBox",
    id: "carto-components-logo-watermark_svg__c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    "in": "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.226 24C55.84 24 61.2 18.627 61.2 12S55.84 0 49.226 0c-6.613 0-11.974 5.373-11.974 12s5.361 12 11.974 12z",
    id: "carto-components-logo-watermark_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16 15.988c1.672 0 2.639-.733 3.356-1.728L5.93 13.123c-.456.558-.923.93-1.716.93-1.065 0-1.814-.897-1.814-2.045v-.022c0-1.115.75-2.033 1.814-2.033.728 0 1.227.36 1.662.896l1.586-1.235c-.674-.93-1.673-1.586-3.226-1.586-2.303 0-3.998 1.75-3.998 3.98v.022c0 2.285 1.749 3.958 3.921 3.958zm6.97-.153h2.206l.543-1.378h2.943l.543 1.378h2.26l-3.237-7.708h-2.031l-3.227 7.708zm3.368-3.029l.858-2.165.847 2.165h-1.705zm9.23 3.029h2.107v-2.318h.935l1.531 2.318h2.422l-1.814-2.668c.945-.405 1.565-1.18 1.565-2.362v-.022c0-.754-.228-1.333-.674-1.782-.51-.514-1.314-.82-2.476-.82h-3.596v7.654zm2.107-3.98v-1.848h1.39c.696 0 1.141.306 1.141.919v.021c0 .558-.423.908-1.13.908h-1.4zM49.226 8a3.996 3.996 0 013.991 4c0 2.21-1.787 4-3.99 4a3.996 3.996 0 01-3.992-4c0-2.21 1.787-4 3.991-4zm-8.077.181v1.859h-2.281v5.795H36.76V10.04h-2.27V8.181h6.659z",
    id: "carto-components-logo-watermark_svg__d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.884)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#carto-components-logo-watermark_svg__a)",
    xlinkHref: "#carto-components-logo-watermark_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "#FFF",
    xlinkHref: "#carto-components-logo-watermark_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.884)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#carto-components-logo-watermark_svg__c)",
    xlinkHref: "#carto-components-logo-watermark_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#carto-components-logo-watermark_svg__d"
  })))));
}

export default __webpack_public_path__ + "82b7c0e73809bd48109952eec60b1a44.svg";
export { SvgCartoComponentsLogoWatermark as ReactComponent };